import React, { useState, useEffect } from 'react';
import './AffiliateCommunicationTracker.css';
import { apiClient } from '../api/api';
import { UserCircle2 } from 'lucide-react';
import GradientHeading from './GradientHeading';
const AffiliateCommunicationTracker = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedUserId, setSelectedUserId] = useState(null);


  useEffect(() => {
    fetchUsers();
    // Optionally, you can add a focus event to re-fetch when the page regains focus
    // const handleFocus = () => fetchUsers();
    // window.addEventListener('focus', handleFocus);
    // return () => window.removeEventListener('focus', handleFocus);
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await apiClient.get('/tiktok/affiliate-communications', {
        withCredentials: true,
        credentials: 'include'
      });
      setUsers(response.data.users || []);
      if (response.data.users && response.data.users.length > 0) {
        setSelectedUserId(response.data.users[0].id);
      }
    } catch (err) {
      setError('Failed to fetch affiliate communications.');
      console.error('Error fetching users:', err);
    } finally {
      setLoading(false);
    }
  };

  const [messages, setMessages] = useState([]);
  const [messagesLoading, setMessagesLoading] = useState(false);

  // Fetch messages when selectedUserId changes
  useEffect(() => {
    if (selectedUserId) {
      fetchMessages(selectedUserId);
    } else {
      setMessages([]);
    }
  }, [selectedUserId]);

  useEffect(() => {

    }, []);

  const fetchMessages = async (conversationId) => {
    setMessagesLoading(true);
    try {
      const response = await apiClient.get(`/tiktok/affiliate-communications/${conversationId}/messages`, {
        withCredentials: true,
        credentials: 'include'
      });
      setMessages(response.data.messages || []);
    } catch (err) {
      setMessages([]);
      console.error('Error fetching messages:', err);
    } finally {
      setMessagesLoading(false);
    }
  };



  const selectedUser = users.find(u => u.id === selectedUserId);

  return (
    <div className="affiliate-chat-outer">
      <div className="affiliate-chat-container super-modern-gradient-bg">
      <div className="chat-sidebar glassy-sidebar">
        <div className="sidebar-header">
          <GradientHeading>Affiliate Communication Tracker</GradientHeading>
        </div>
        {loading ? (
          <div className="sidebar-loading">Loading...</div>
        ) : error ? (
          <div className="sidebar-error">{error}</div>
        ) : null}
        <ul className="user-list">
          {users.map(user => (
            <li
              key={user.id}
              className={`user-list-item modern-list-item ${user.id === selectedUserId ? 'selected' : ''}`}
              onClick={() => setSelectedUserId(user.id)}
            >
              {user.avatar ? (
                <img src={user.avatar} alt={user.username} className="user-avatar modern-avatar" />
              ) : (
                <span className="user-avatar modern-avatar"><UserCircle2 size={32} /></span>
              )}
              <span className="user-name modern-username">{user.username}</span>
            </li>
          ))}
          {(!loading && users.length === 0) && <li className="no-users">No affiliates found.</li>}
        </ul>
      </div>
      <div className="chat-main glassy-main">
        {selectedUser ? (
          <div className="chat-header modern-chat-header">
            {selectedUser.avatar ? (
              <img src={selectedUser.avatar} alt={selectedUser.username} className="user-avatar-large modern-avatar-large" />
            ) : (
              <span className="user-avatar-large modern-avatar-large"><UserCircle2 size={48} /></span>
            )}
            <div>
              <h3 className="modern-username-large">{selectedUser.username}</h3>
              <span className="user-id modern-user-id">ID: {selectedUser.id}</span>
            </div>
          </div>
        ) : (
          <div className="chat-header empty-chat-header">Select an affiliate to view messages</div>
        )}
        <div className="chat-messages modern-chat-messages">
          {messagesLoading ? (
            <div className="loading-messages">Loading messages...</div>
          ) : messages.length > 0 ? (
            messages.map(msg => (
              <div key={msg.id} className={`chat-message modern-message-bubble ${msg.sender_id === selectedUserId ? 'from-user' : 'from-me'}`}>
                <div className="message-content modern-message-content">{msg.text}</div>
                <div className="message-meta modern-message-meta">{msg.type} • {msg.create_time ? new Date(msg.create_time * 1000).toLocaleString() : ''}</div>
              </div>
            ))
          ) : (
            <div className="no-messages">No messages yet.</div>
          )}
        </div>
      </div>
      </div>
    </div>
  );
};

export default AffiliateCommunicationTracker;

